// Plain HTTP calls to the same origin the app is served from — separate from
// the Colyseus room traffic in net.ts. Mirrors the native client's src/lib/api.ts.

import { playerId, playerName } from "./identity";

/** Admin-curated set of game ids pinned to the top of the lobby's "All" view. */
export async function getFeatured(): Promise<string[]> {
  try {
    const res = await fetch("/api/featured");
    const data = await res.json();
    return Array.isArray(data?.ids) ? data.ids : [];
  } catch {
    return [];
  }
}

export interface BoardEntry {
  name: string;
  score: number;
  detail: string;
  tag: string;
  mine: boolean;
}

/** Browse a game's top scores without joining a room — for the standalone
 * Leaderboards screen. */
export async function getLeaderboard(game: string, limit = 20): Promise<BoardEntry[]> {
  try {
    const res = await fetch(
      `/api/leaderboard/${encodeURIComponent(game)}?limit=${limit}&pid=${encodeURIComponent(playerId())}`,
    );
    const data = await res.json();
    return Array.isArray(data?.top) ? data.top : [];
  } catch {
    return [];
  }
}

export type FeedbackType = "bug" | "suggestion";

export async function submitFeedback(type: FeedbackType, message: string): Promise<{ ok: boolean }> {
  try {
    const res = await fetch("/api/feedback", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type,
        message,
        name: playerName(),
        playerId: playerId(),
        platform: "web",
        appVersion: "web",
      }),
    });
    return await res.json();
  } catch {
    return { ok: false };
  }
}
